import request from "../utils/request"

export default {
    register(data) {
        return request({
            url: `/user?ac=register`,
            method: 'post',
            data
        })
    },

    login(data) {
        return request({
            url: `/user?ac=login`,
            method: 'post',
            data
        })
    },

    getMineInfo() {
        return request({
            url: `/user?ac=mine`,
            method: 'get'
        })
    },

    /**
     * 功能：获取当前用户的专家认证申请状态。
     * 参数：无。
     */
    getExpertApplyInfo() {
        return request({
            url: `/user?ac=expertApplyInfo`,
            method: 'get'
        })
    },

    /**
     * 功能：提交当前用户的专家认证申请。
     * 参数：data 申请表单数据，包含 mobile 和 authCondition。
     */
    submitExpertApply(data) {
        return request({
            url: `/user?ac=expertApply`,
            method: 'post',
            data
        })
    },

    /**
     * 功能：提交当前用户意见反馈。
     * 参数：data 反馈表单数据，包含 content、contact、imageId。
     */
    submitFeedback(data) {
        return request({
            url: `/feedback?ac=submit`,
            method: 'post',
            data
        })
    },

    getCoinLedger(params) {
        return request({
            url: `/user?ac=coinLedger`,
            method: 'get',
            params
        })
    },

    getMineOrders(params) {
        return request({
            url: `/user?ac=orders`,
            method: 'get',
            params
        })
    },

    getMineFollows(params) {
        return request({
            url: `/user?ac=follows`,
            method: 'get',
            params
        })
    },

    getMineFans(params) {
        return request({
            url: `/user?ac=fans`,
            method: 'get',
            params
        })
    },

    updateUserProfile(data) {
        return request({
            url: `/user?ac=updateProfile`,
            method: 'post',
            data
        })
    },

    changeUserPassword(data) {
        return request({
            url: `/user?ac=changePassword`,
            method: 'post',
            data
        })
    },

    logout() {
        return request({
            url: `/user?ac=logout`,
            method: 'post'
        })
    },

    toggleUserFollow(data) {
        return request({
            url: `/user?ac=followToggle`,
            method: 'post',
            data
        })
    },

    togglePredictFavorite(data) {
        return request({
            url: `/user?ac=favoriteToggle`,
            method: 'post',
            data
        })
    }
}
